import Seo from "@/components/Seo";
import { PageHero } from "@/components/Primitives";
import { BUSINESS } from "@/data/site";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    overline: "Your privacy",
    body: [
      ["Information we collect", `We collect information you provide when you request care, apply as a sitter, or contact us — such as your name, email, phone number, location, and details about your care needs.`],
      ["How we use it", `We use your information solely to match you with caregivers, confirm bookings, respond to inquiries, and improve our service. We never sell your personal information.`],
      ["Data storage", `Your information is stored securely and access is limited to our staff who coordinate your care.`],
      ["Contact", `Questions about your privacy? Email us at ${BUSINESS.email} or call ${BUSINESS.phone}.`],
    ],
  },
  terms: {
    title: "Terms of Service",
    overline: "The details",
    body: [
      ["Bookings", `All sitter requests are subject to caregiver availability and a ${BUSINESS.minHours}-hour minimum per booking. Requests are confirmed by our team; submitting a request does not guarantee placement.`],
      ["Pricing", `Pricing displayed on this site is for reference only. Final details are confirmed with you directly. No online payments are processed through this website.`],
      ["Conduct", `Families and caregivers agree to treat one another with respect and to communicate any concerns to our office promptly.`],
      ["Contact", `Questions? Email ${BUSINESS.email} or call ${BUSINESS.phone}.`],
    ],
  },
  accessibility: {
    title: "Accessibility Statement",
    overline: "For everyone",
    body: [
      ["Our commitment", `Mom's Best Friend Sitters is committed to ensuring our website is accessible to everyone, and we strive to meet WCAG 2.2 AA standards.`],
      ["Ongoing effort", `We continually review and improve the accessibility of our site, including keyboard navigation, color contrast, and screen-reader support.`],
      ["Need help?", `If you experience any difficulty using this site, please call us at ${BUSINESS.phone} and we'll be glad to assist you directly.`],
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type];
  return (
    <>
      <Seo title={c.title} description={`${c.title} for Mom's Best Friend Sitters.`} />
      <PageHero overline={c.overline} title={c.title} />
      <section className="container-mbf py-16 md:py-24 max-w-3xl">
        <div className="space-y-8">
          {c.body.map(([h, p]) => (
            <div key={h} data-testid={`legal-section-${h}`}>
              <h2 className="font-serif text-xl md:text-2xl text-espresso mb-3">{h}</h2>
              <p className="text-base text-stoneish leading-relaxed">{p}</p>
            </div>
          ))}
        </div>
        <p className="mt-12 text-sm text-stoneish">Last updated {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}.</p>
      </section>
    </>
  );
}
